import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, ArrowRight } from "lucide-react";
import { Reveal, SectionHead } from "@/components/Reveal";
import { NLMap } from "@/components/NLMap";
import { PHONE, PHONE_TEL, EMAIL } from "@/data/content";
import { btnPrimary, btnSecondary } from "@/lib/ui";

export const ContactSection = () => (
  <section className="py-24 md:py-36" data-testid="contact-section">
    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-10">
      <div className="grid gap-14 lg:grid-cols-2 lg:items-center">
        <div>
          <SectionHead nr="11" overline="Contact" title="Bespreek uw locatie met een specialist" />
          <Reveal delay={0.1}>
            <p className="mt-8 max-w-xl text-base leading-relaxed text-[#CBD3D9]">
              Wilt u weten welke delen van uw terrein thermisch bewaakt kunnen worden? Stuur ons een
              plattegrond of enkele foto's. Wij bekijken de risicogebieden, zichtlijnen en mogelijke
              montageposities.
            </p>
          </Reveal>
          <Reveal delay={0.2}>
            <ul className="mt-8 grid gap-4 text-sm text-[#F5F7F9]">
              <li>
                <a href={PHONE_TEL} className="flex items-center gap-3 transition-colors hover:text-[#62C3F0]" data-testid="contact-phone-link">
                  <span className="flex h-10 w-10 items-center justify-center rounded-full border border-[#2B9FD7]/30 bg-[#2B9FD7]/10 text-[#62C3F0]"><Phone size={16} /></span>
                  Telefoon: {PHONE}
                </a>
              </li>
              <li>
                <a href={`mailto:${EMAIL}`} className="flex items-center gap-3 transition-colors hover:text-[#62C3F0]" data-testid="contact-email-link">
                  <span className="flex h-10 w-10 items-center justify-center rounded-full border border-[#2B9FD7]/30 bg-[#2B9FD7]/10 text-[#62C3F0]"><Mail size={16} /></span>
                  E-mail: {EMAIL}
                </a>
              </li>
              <li className="flex items-center gap-3">
                <span className="flex h-10 w-10 items-center justify-center rounded-full border border-[#2B9FD7]/30 bg-[#2B9FD7]/10 text-[#62C3F0]"><MapPin size={16} /></span>
                Werkgebied: heel Nederland
              </li>
            </ul>
          </Reveal>
          <Reveal delay={0.3} className="mt-10 flex flex-wrap gap-4">
            <Link to="/offerte" className={btnPrimary} data-testid="contact-cta-analyse">
              Vraag een locatie analyse aan <ArrowRight size={16} />
            </Link>
            <a href={PHONE_TEL} className={btnSecondary} data-testid="contact-cta-call">
              <Phone size={16} /> Bel direct
            </a>
          </Reveal>
        </div>
        <Reveal delay={0.2} className="flex justify-center">
          <NLMap />
        </Reveal>
      </div>
    </div>
  </section>
);
